import {getSTSToken} from "@/api/tool/common";
import COS from 'cos-js-sdk-v5';
import OSS from 'ali-oss'


//这种会自动更新token ,可以使用这个
/*
  const baseUrl= process.env.VUE_APP_BASE_API
  const cos = new COS({
  getAuthorization: function (options, callback) {
    const url = baseUrl+'/common/oss'
    const xhr = new XMLHttpRequest()
    let data = null
    let credentials = null
    xhr.open('POST', url, true)
    xhr.onload = function (e) {
      try {
        data = JSON.parse(e.target.responseText);
        credentials = data.data;
      } catch (e) {
        console.log(e)
      }
      if (!data || !credentials) {
        return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2));
      }
      callback({
        TmpSecretId: credentials.accessKeyId,        // 临时密钥的 tmpSecretId
        TmpSecretKey: credentials.accessKeySecret,      // 临时密钥的 tmpSecretKey
        SecurityToken: credentials.securityToken, // 临时密钥的 sessionToken
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: credentials.startTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: credentials.expiration,
      })
    }
    xhr.send();
  }
})*/



export function ossClient(stsToken) {
  const config = {
    accessKeyId: stsToken.accessKeyId,
    accessKeySecret: stsToken.accessKeySecret,
    bucket: stsToken.bucket,
    region: stsToken.region,
    secure: true
  }
  if (stsToken.securityToken) {
    config.stsToken = stsToken.securityToken
  }
  return new OSS(config)
}


// 上传请求头（字幕等场景允许覆盖同名文件）
export function getUploadHeaders() {
  return {}
}

/**
 * 确保 URL 包含 https:// 前缀
 * @param {String} url - 原始 URL
 * @returns {String} 包含 https:// 前缀的 URL
 */
export function ensureHttpsUrl(url) {
  if (!url) return url
  // 如果已经包含 http:// 或 https://，直接返回
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  // 否则添加 https:// 前缀
  return 'https://' + url
}

/**
 * 上传方法
 * 支持腾讯云,阿里云的直传
 * @param filePath 文件名称,自己拼好前面的日期 , 可以调用uploadOss 方法生成文件的前缀
 * @param file 具体的文件
 */
export async function uploadObject(filePath, file, onProgress) {
  const stsToken = await getSTSToken()
  if (stsToken.data.type === 'aliyun') {
    return uploadOssObject(filePath, file, stsToken, onProgress)
  } else if (stsToken.data.type === 'tencent') {
    return uploadCosObject(filePath, file, stsToken, onProgress)
  }
  throw new Error('未知的OSS类型: ' + stsToken.data.type)
}

export async function uploadOssObject(filePath, file, stsToken, onProgress) {
  const headers = getUploadHeaders()
  const client = ossClient(stsToken.data)
  const progress = onProgress ? function(p) { onProgress(p) } : undefined
  const isSmallFile = file.size <= 5 * 1024 * 1024
  const result = isSmallFile
    ? await client.put(filePath, file, { headers, progress })
    : await client.multipartUpload(filePath, file, { headers, progress })
  if (result.res && (result.res.status === 200 || result.res.status === 204)) {
    // 如果 staticUrl 存在，使用 staticUrl；否则使用 signatureUrl 生成完整URL
    if (stsToken.data.staticUrl) {
      const url = stsToken.data.staticUrl + filePath
      return ensureHttpsUrl(url)
    } else {
      // 使用 signatureUrl 生成完整URL（有效期1年）
      const url = client.signatureUrl(filePath, { expires: 31536000 })
      return ensureHttpsUrl(url)
    }
  }
}

export async function uploadCosObject(filePath, file, token, onProgress) {
  const cos = new COS({
    SecretId: token.data.accessKeyId,        // 临时密钥的 tmpSecretId
    SecretKey: token.data.accessKeySecret,      // 临时密钥的 tmpSecretKey
    XCosSecurityToken: token.data.securityToken, // 临时密钥的 sessionToken
    Protocol: 'https:',  // 确保使用HTTPS协议
  })

  let data = await cos.uploadFile({
    Bucket: token.data.bucket, /* 填入您自己的存储桶，必须字段 */
    Region: token.data.region,  /* 存储桶所在地域，例如 ap-beijing，必须字段 */
    Key: filePath,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
    Body: file,
    SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
    onProgress: function(progressData) {
      if (onProgress) {
        onProgress(progressData)
      }
    },
    onFileFinish: function (err, data, options) {   /* 非必须 */
      console.log(options.Key + '上传' + (err ? '失败' : '完成'));
    },

  });
  if (data.statusCode === 200) {
    // 如果 staticUrl 存在，使用 staticUrl；否则构建标准的COS URL
    if (token.data.staticUrl) {
      const url = token.data.staticUrl + (token.data.staticUrl.endsWith('/') ? '' : '/') + filePath;
      return ensureHttpsUrl(url);
    } else {
      // 构建标准的COS URL（假设bucket是公开访问的）
      // 格式：https://{bucket}.cos.{region}.myqcloud.com/{filePath}
      const url = `https://${token.data.bucket}.cos.${token.data.region}.myqcloud.com/${filePath}`;
      return ensureHttpsUrl(url);
    }
  }
  return '';
}


export function uploadOss(fileName, prefix) {
  // 获取文件后缀
  const suffix = fileName.substring(fileName.lastIndexOf('.'))
  // 生成文件名称
  const filePath = generateFilePath(prefix, suffix)
  return filePath
}

/**
 *  生成文件扩展名称
 * @param {prefix} 路径前缀
 * @param {suffix} 文件后缀
 */
export function generateFilePath(prefix, suffix) {
  let now = new Date()
  let year = now.getFullYear(),
    month = now.getMonth() + 1,
    day = now.getDate()
  let dir = prefix + '/' + year + '/' + (month < 10 ? '0' + month : month) + '/' + (day < 10 ? '0' + day : day) +
    '/' + now.getTime() + generateRdStr() + suffix
  return dir
}

/**
 * 生成随机字符串
 * @returns
 */
export function generateRdStr() {
  let len = 15
  let text = ''
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < len; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

